import { render, staticRenderFns } from "./MessageView.vue?vue&type=template&id=0fe6b9f4&scoped=true"
import script from "./MessageView.vue?vue&type=script&lang=ts"
export * from "./MessageView.vue?vue&type=script&lang=ts"
import style0 from "./MessageView.vue?vue&type=style&index=0&id=0fe6b9f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe6b9f4",
  null
  
)

export default component.exports